module.exports = __webpack_public_path__ + "img/KM-360A_06.be94c521.jpg";